import React, { useContext } from 'react';
import { format } from 'date-fns';
import { ReportDateContext } from '../../core/context/report-date-context';

import './Asterix.scss';

export enum AsterixType {
  basic,
  alter,
}

interface IAsterix {
  type: AsterixType;
}

export default function Asterix({ type }: IAsterix): JSX.Element {
  const { settlementDate } = useContext(ReportDateContext);
  let outputJSX: JSX.Element;

  const d = format(settlementDate, 'd MMM yyyy');

  if (type === AsterixType.basic) {
    outputJSX = (
      <div className="Asterix fse">
        <div className="Asterix__delimiter" />
        <p className="Asterix__basic">* Settlement from {d}</p>
      </div>
    );
  } else {
    outputJSX = <p className="Asterix__alter">* Settlement from {d}</p>;
  }

  return outputJSX;
}
